<div class="login-page">
  <div class="login-shell">
    <div class="brand-panel">
      <div class="brand-orb orb-1"></div>
      <div class="brand-orb orb-2"></div>
      <div class="brand-orb orb-3"></div>

      <div class="brand-content">
        <div class="brand-logo">
          <i class="bi bi-shield-lock-fill"></i>
          <span>Admin Panel</span>
        </div>

        <img src="assets/login.png" alt="" class="brand-illustration" />

        <h2 class="brand-heading">Manage every tenant, service &amp; user in one place</h2>
        <p class="brand-text">Secure, centralized control for your entire platform — configure SSO, services, and access with confidence.</p>
      </div>
    </div>

    <div class="form-panel">
      <div class="login-card">
        <h1 class="login-title">Welcome back</h1>
        <p class="login-subtitle">Sign in to access the admin panel.</p>

        <form [formGroup]="form" (ngSubmit)="submit()" class="login-form">
          <div class="form-group">
            <label for="username">Username</label>
            <div class="input-with-icon">
              <i class="bi bi-person"></i>
              <input id="username" type="text" formControlName="username" autocomplete="username" placeholder="Enter your username" />
            </div>
            @if (form.controls.username.invalid && form.controls.username.touched) {
              <span class="field-error">Username is required.</span>
            }
          </div>

          <div class="form-group">
            <label for="password">Password</label>
            <div class="input-with-icon">
              <i class="bi bi-lock"></i>
              <input
                id="password"
                [type]="showPassword ? 'text' : 'password'"
                formControlName="password"
                autocomplete="current-password"
                placeholder="Enter your password"
              />
              <button type="button" class="toggle-visibility" (click)="showPassword = !showPassword" tabindex="-1">
                <i class="bi" [class.bi-eye]="!showPassword" [class.bi-eye-slash]="showPassword"></i>
              </button>
            </div>
            @if (form.controls.password.invalid && form.controls.password.touched) {
              <span class="field-error">Password is required.</span>
            }
          </div>

          <button type="submit" class="login-button" [disabled]="loading">
            @if (loading) {
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              <span>Signing in…</span>
            } @else {
              <span>Sign in</span>
              <i class="bi bi-arrow-right"></i>
            }
          </button>
        </form>

        <div class="login-divider"><span>or continue with</span></div>

        <button type="button" class="sso-button" (click)="loginWithSso()">
          <i class="bi bi-microsoft"></i>
          <span>Sign in with Microsoft SSO</span>
        </button>

        <p class="login-footer">Protected access · Contact your administrator for an account.</p>
      </div>
    </div>
  </div>
</div>
